import React from "react"
import PropTypes from "prop-types"
import {findDOMNode} from "react-dom"

import {PopoverMenuItemType} from "../../../../../../gd-components/popover-menu/popover-menu/const"
import PopoverMenuSeparator from "../../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuHeader from "../../../../../../gd-components/popover-menu/popover-menu/popover-menu-header"

const debug = false
// const debug = "FieldTimeOfDay_DropdownPopoverOptionsSelector"

export default class FieldTimeOfDay_DropdownPopoverOptionsSelector extends React.Component<any,any> {

    public optionRef            : any
    public highlightedOptionRef : any

    static propTypes = {
        parent              : PropTypes.object,
        field               : PropTypes.object,

        searchString        : PropTypes.string,

        highlightedOption   : PropTypes.object,
        currentOption       : PropTypes.object,

        keyboardNavigation  : PropTypes.bool,

        onUpdateScroll      : PropTypes.func,
        onOptionHighlighted : PropTypes.func,
        onOptionClick       : PropTypes.func,
    }

    static defaultProps = {
        keyboardNavigation  : true
    }

    constructor(props:any) {
        super(props)

        let currentCursorKey = null
        if (props.currentOption) {
            currentCursorKey = _.findIndex(this._getOptions(), (option:any)=>_.isEqual(option.value, props.currentOption.value))
        } else if (props.highlightedOption) {
            currentCursorKey = _.findIndex(this._getOptions(), (option:any)=>_.isEqual(option.value, props.highlightedOption.value))
        }

        this.state = {
            currentCursorKey: currentCursorKey
        }

        // references for options for keyboard navigation
        this.optionRef              = {}
        this.highlightedOptionRef   = null // required for scroll to selected option
    }

    componentDidMount() {
        debug && console.log(debug, "componentDidMount", this.props.field.scrollToSelected)

        if (!this.props.field.scrollToSelected) return

        // setTimeout is required to call it on next frame for VScroll to finish rendering
        setTimeout(()=>{
            const node = this.highlightedOptionRef ? findDOMNode(this.highlightedOptionRef) : null
            if (node) this.props.onUpdateScroll(node, true)
        }, 0)
    }

    componentDidUpdate(prevProps:any, prevState:any, snapshot:any) {
        const node = this.optionRef[this.state.currentCursorKey] ? findDOMNode(this.optionRef[this.state.currentCursorKey]) : null

        // scroll for cursor to be visible
        if (node) this.props.onUpdateScroll(node)
    }

    _getOptions = () => {

        // Changed by Vic Mar 15 2023 - be able to use smart
        // let options = this.props.field.getOptions().slice()
        let options = this.props.field.getOptionsForEdit(this.props.model).slice()

        options = _.filter(options, option => !option.notSelectable)

        // filter options by search string
        let searchString = this.props.searchString
        if (searchString) {
            searchString = searchString.toLowerCase()
            options = _(options)
                .filter(option => option.label && option.label.toLowerCase().includes(searchString))
                .value()
        }

        // add no value if necessary
        if (this.props.field.noValueOption) {
            options.unshift({
                value: null,
                label: this.props.field.noValueOptionLabel
            })
        }

        return options
    }

    onClickOption = (option:any) => {
        this.props.onOptionClick(option)
    }

    onChangeCursorOption = (newValue:any, callback?: callback) => {
        this.setState({
            currentCursorKey: newValue
        }, callback)
    }

    onPopoverKeyDown = (event:any) => {
        if (!this.props.keyboardNavigation) return

        const options = this._getOptions()

        let newValue

        switch(event.key) {
            case 'Escape': this.props.parent.hidePopover(); break

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1
                    if (newValue < 0) newValue = 0
                }

                this.onChangeCursorOption(newValue, ()=>{
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption && this.props.onOptionHighlighted) {
                        this.props.onOptionHighlighted(curOption)
                    }
                })
                break

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > options.length - 1) newValue = options.length - 1
                }

                this.onChangeCursorOption(newValue, ()=>{
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption && this.props.onOptionHighlighted) {
                        this.props.onOptionHighlighted(curOption)
                    }
                })
                break

            /*case 'Enter':
                if (this.state.currentCursorKey !== null) {
                    const curOption = options[this.state.currentCursorKey]
                    if (curOption) this.onClickOption(curOption)
                }
                break*/
        }
    }

    _optionReference = (key:any, r:any) => {
        this.optionRef[key] = r
        if (r?.props.isHighlighted || r?.props.isSelected) this.highlightedOptionRef = r
    }

    render() {
        const {field} = this.props
        const options = this._getOptions()
        const highlightedOption = options[this.state.currentCursorKey]
        const {currentOption} = this.props

        return (
            <React.Fragment>
                {_.map(options, (option, key)=> {
                    if (option.excludeFromSelectable) return false

                    if (option.type === PopoverMenuItemType.SEPARATOR) {
                        return <PopoverMenuSeparator key={key} />
                    }

                    if (option.type === PopoverMenuItemType.HEADER) {
                        return <PopoverMenuHeader title={option.title} key={key} />
                    }

                    const isHighlighted = highlightedOption && highlightedOption.value === option.value
                    const isSelected    = currentOption && currentOption.value === option.value

                    return <field.components.PopoverOption ref              = {(r:any)=>this._optionReference(key, r)}
                                                           // key              = {option.value || key}
                                                           key              = {key} // patch - option value 0 false ... sovpadaet s key... prikol
                                                           option           = {option}
                                                           isHighlighted    = {isHighlighted}
                                                           isSelected       = {isSelected}
                                                           onClick          = {()=>this.onClickOption(option)}/>
                    }
                )}
            </React.Fragment>
        )
    }
}
